import React from 'react'

import { Container } from './styles'

import Indicators from '../Indicators'
import ParticipantTile from '../Tile'

const Preview = () => {
    return (
        <Container>
            <ParticipantTile />
            <Indicators />
        </Container>
    )
}

export default Preview
